<script lang="ts" setup>
import { useTemplateRef } from 'vue';
import xss from 'xss';
import { parseFragment, serialize } from 'parse5';

defineOptions({
  name: 'SanitizeHtml',
});

const props = defineProps({
  value: {
    type: String,
    default: '',
  },
});

const elRef = useTemplateRef('el');

const sanitizeHtml = (html: string) => {
  try {
    const standardizeHtml = serialize(parseFragment(html || ''));

    return xss(standardizeHtml, {
      whiteList: {
        ...(xss as any).whiteList,
        pre: ['style', 'class'],
        span: ['style'],
        div: ['style'],
        section: ['style', 'id'],
        p: ['style', 'align', 'id'],
        a: ['target', 'href', 'title', 'style', 'id', 'name'],
        h1: ['style', 'align', 'id'],
        h2: ['style', 'align', 'id'],
        h3: ['style', 'align', 'id'],
        h4: ['style', 'align', 'id'],
        h5: ['style', 'align', 'id'],
        h6: ['style', 'align', 'id'],
        strong: ['style'],
        ul: ['style'],
        ol: ['style', 'start'],
        img: ['style', 'src', 'class', 'id'],
      },
    });
  }
  catch (error) {
    console.error('HTML sanitization failed:', error);

    return '';
  }
}

defineExpose({
  getElement: () => elRef.value,
});
</script>

<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div v-html="sanitizeHtml(props.value)" ref="el"></div>
</template>

<style lang="scss" scoped>
</style>
